// @flow
/* eslint-disable import/prefer-default-export */
export const CIRCULAR_BUFFER_STEPS = 64;
export const DECIMAL_SEPARATORS = '.,';



// WEBPACK FOOTER //
// ./utils/geometryConstants.js